<div class="content-container table-comp mb-3">
  <div class="title">
    <mwp-text-translate text="Tobacco Question" jsonKey="tobaccoQuestion" />
  </div>
  <div class="content">
    @if (isSingleQuestion) {
      <div class="d-inline-flex align-items-center">
        <mwp-button-toggle [form]="tobaccoFormGroup" nameForControl="isSmoker" [dataEnum]="booleanEnum" />
        <div class="ms-2">
          {{tobaccoModel.question}}
        </div>
      </div>
    }
    @if (!isSingleQuestion) {
      <div class="pb-3">
        {{tobaccoModel.question}}
      </div>
      <div>
        <mwp-table-formarray [form]="tobaccoFormGroup" [tableColumns]="tobaccoColumns" [dataSource]="tobaccoItemData" [arrayName]="tobaccoArrayName" />
      </div>
    }
    <div class="footer">
      @if (!hideWizardControl) {
        <mwp-benefit-enrollment-wizard-control [isContinueDisabled]="tobaccoFormGroup.invalid" (emitComplete)="submitComplete()"></mwp-benefit-enrollment-wizard-control>
      }
      @if (hideWizardControl) {
        <div class="d-inline-flex justify-content-end w-100 mt-3 mb-2">
          <button class="mwp-button-back me-3" (click)="back()">
            <mwp-text-translate text="Back" jsonKey="back" />
          </button>
          <button class="mwp-button-secondary me-3" (click)="cancel()">
            <mwp-text-translate text="Cancel" jsonKey="cancel" />
          </button>
          <button class="mwp-button" [disabled]="tobaccoFormGroup.invalid" (click)="submitComplete()">
            <mwp-text-translate text="Confirm" jsonKey="confirm" />
          </button>
        </div>
      }
    </div>
  </div>
</div>
